









































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ShipmentDTO } from "@/model/data.model";
import { EventBus } from "@/event-bus";
import ProformaService from "@/services/ProformaService";
import { ShipmentService } from "@/services/ShipmentService";
import { ShipmentListItem } from "@/model/component.model";
import { alertDangerReason, popupFileBase64 } from "@/services/Helpers";
import { MBEShipServiceBusiness } from "@/model/enumeration.model";

@Component({})
export default class PostSaveModal extends Vue {
  @Prop() shipment: ShipmentDTO;

  closeExecuted = false;

  closeModalDismiss(e: any) {
    EventBus.$emit("out-of-modal");
    this.$router.push({ name: "ShipmentsMenuNew" });
  }

  printMBEWaybill() {
    const shipment_ids = [this.shipment.shipmentId];
    const language = this.$store.getters["customer/config"].language;
    const thermicConfig = this.$store.getters["customer/thermicConfig"];
    const mbeWaybillConfig = thermicConfig.find((el: any) => el.courierId == 0);
    const thermicPrint = mbeWaybillConfig
      ? mbeWaybillConfig.printThermicFormat
      : false;
    const format = thermicPrint ? "f4x6" : "fA4"; // fA4, f4x6, f4x8, f5x9

    ShipmentService.printMBEWaybill(shipment_ids, language, format)
      .then(res => {
        if (res.length === 0) {
          this.$snotify.warning("No MBE waybills");
        } else {
          res.forEach((base64document: string) => {
            popupFileBase64(base64document, "PDF", `PrintMBEWaybill.pdf`, this);
          });
        }
      })
      .catch(err => this.$snotify.error("Error retrieving shipment/s waybill"));
  }

  printMergedWaybills() {
    const shipmentIds = [this.shipment.shipmentId];
    const language = this.$store.getters["customer/config"].language;
    const thermicConfig = this.$store.getters["customer/thermicConfig"];
    const mbeWaybillConfig = thermicConfig.find((el: any) => el.courierId == 0);
    const thermicPrint = mbeWaybillConfig
      ? mbeWaybillConfig.printThermicFormat
      : false;
    const format = thermicPrint ? "f4x6" : "fA4";
    const visiblePriceInWaybill = this.$store.getters["customer/config"]
      .visiblePriceInWaybill;

    ShipmentService.printMergedWaybills(
      shipmentIds,
      language,
      format,
      visiblePriceInWaybill
    )
      .then(res => {
        if (res.length === 0) {
          this.$snotify.warning(this.$t("notification_no_waybills").toString());
        } else {
          res.forEach((url: string) => {
            window.open(url, "_blank");
          });
        }
      })
      .catch(err => this.$snotify.error("Error retrieving shipment/s waybill"));
  }

  printMOS() {
    ShipmentService.printMOS(
      this.shipment.shipmentId,
      this.$store.getters.language
    )
      .then(res => popupFileBase64(res, "PDF", `PrintMOS.pdf`, this))
      .catch(err => this.$snotify.error("Error retrieving shipment MOS"));
  }

  doShipmentClosure() {
    ShipmentService.closeShipmentsById([this.shipment.shipmentId])
      .then((res: ShipmentListItem[]) => {
        this.$snotify.success("Shipments have been closed.");
        this.closeExecuted = true;
        ShipmentService.printManifest(res)
          .then((base64document: any) => {
            popupFileBase64(base64document, "PDF", `PrintManifest.pdf`, this);
          })
          .catch(err => {
            this.$snotify.error("It's not possible to show the manifest.");
          });
      })
      .catch(err => {
        if (err.response.data.code) {
          const error = this.$t(err.response.data.code);
          this.$snotify.error(String(error));
        } else {
          this.$snotify.error(err.response.data.message);
        }
      });
  }

  redirectToNonClosedShipmentsList() {
    EventBus.$emit("out-of-modal");
    this.$router.push({
      name: "ShipmentsManagement",
      params: { searchTab: "shipment_status_pending_closure" }
    });
  }

  printWaybill() {
    ShipmentService.getWaybillsSignedURLs(this.shipment.shipmentId)
      .then(res => {
        if (res.length === 0) {
          this.$snotify.warning(this.$t("notification_no_waybills").toString());
        } else {
          res.forEach((url: string) => {
            window.open(url, "_blank");
          });
        }
      })
      .catch(err => this.$snotify.error("Error retrieving shipment Waybill"));
  }
  printProforma() {
    ProformaService.prototype
      .printProforma(this.shipment.shipmentId)
      .then(value => {
        popupFileBase64(value, "PDF", "Proforma.pdf", this);
      })
      .catch(err => {
        return alertDangerReason(err, this);
      });
  }
  get showProformaButton() {
    const hideProforma = this.$store.getters["customer/config"]
      .hideStoreProforma;
    if (hideProforma && this.shipment.proforma.createdByStore) return false;
    return (
      this.shipment.addressFrom.cee === false ||
      this.shipment.addressTo.cee === false
    );
  }
}
